module.exports = __webpack_public_path__ + "img/mile1m.a09f40da.webp";